import { RLBaseService } from "./rl-base-service";
import * as Models from "../ts/rlAdmin.models";

export class WorkflowService extends RLBaseService {
    static $inject = ["$resource"];

    constructor(private $resource: ng.resource.IResourceService) {
        super($resource);
    }

    getAvailableWorkflowActions(charTypeID: number, templateID: number, statusID: number) {
        return this.toRLService<Models.IWFAction>("/api/workflow/getavailableworkflowactions").query({ charTypeID: charTypeID, templateID: templateID, statusID: statusID }).$promise;
    }

    getAvailableWorkflowActionsForEncryptedString(encryptedString: string) {
        return this.toRLService<Models.IWFAction>("/api/workflow/getAvailableWorkflowActionsForEncryptedString").query({ encryptedString: encryptedString }).$promise;
    }

    getEntityMergeFields(entityID: string) {
        return this.toRLService<Models.IEntityMergeField>("/api/workflow/getentitymergefields").query({ entityID: entityID }).$promise;
    }

    validateEncrptedString(encryptedString: string) {
        return this.toRLService<Models.IDataResponse<Models.IWorkflowValidateEncryptedString>>("/api/workflow/validateEncrptedString").get({ encryptedString: encryptedString }).$promise;
    }

    executeWorkflow(charTypeID: number, recIDs: number[], actionID: number, processID: number, batchID: string) {
        return this.toRLService<Models.IExecuteWorkflowResult>("/api/workflow/executeworkflow").post({ charTypeID: charTypeID, recIDs: recIDs, actionID: actionID, processID: processID, batchID: batchID }).$promise;
    }

    executeWorkflowAction(encryptedString: string, actionID: number) {
        return this.toRLService<Models.IEmailActionBtnExecuteWorkflowResult>("/api/workflow/executeWorkflowAction").post({ encryptedString: encryptedString, actionID: actionID }).$promise;
    }

    executeWorkflowJob(charTypeID: number, recIDs: number[], actionID: number, processID: number, batchID: string) {
        return this.toRLService<Models.IJobResponse>("/api/workflow/executeworkflowJob").post({ charTypeID: charTypeID, recIDs: recIDs, actionID: actionID, processID: processID, batchID: batchID }).$promise;
    }

    getWorkflowProcesses(charTypeID: number) {
        return this.toRLService<Models.IWFProcess>("/api/workflow/getworkflowprocesses").query({ charTypeID: charTypeID }).$promise;
    }
    getEntityStatusHistory(entityID: string) {
        return this.toRLService<Models.IStatusHistoryItem>("/api/workflow/getentitystatushistory").query({ entityID: entityID }).$promise;
    }
    getDocTemplatesByCharTemplate(request: Models.IDocTemplateByCharTemplateRequest) {
        return this.toRLService<Models.IDocTemplate>("/api/workflow/getDocTemplatesByCharTemplate").query({ charTypeID: request.charTypeID, charTemplateID: request.charTemplateID }).$promise;
    }
    getNotificationAttachments(charTypeID: number, recID: number, trxRevID: number, msgID: number, parentRecID: number) {
        var data = {
            charTypeID: charTypeID,
            recID: recID,
            trxRevID: trxRevID,
            msgID: msgID,
            parentRecID: parentRecID
        };
        return this.toRLService<string>("/api/workflow/getnotificationattachments").query(data).$promise;
    }

    sendNotifications(request: Models.IWFSendNotificationsRequest) { 
        return this.toRLService<Models.IJobResponse>("/api/workflow/sendnotifications").post(request).$promise; 
    } 

    sendNotification(notification: Models.IWFSendNotificationRequest) {
        return this.toRLService<any>("/api/workflow/sendnotification").post(notification).$promise;
    }

    setEntityStatus(request: Models.IWFEntityStatusUpdateRequest) {
        return this.toRLService<boolean>("/api/workflow/SetEntityStatus").post(request).$promise;
    }

    createBatchID() {
        return this.toRLService<Models.ICreateBatchIDResult>("/api/workflow/CreateBatchID").get().$promise;
    }

    mergeAndAddNotificationToQueue(notification: Models.IWFSendNotificationRequest) {
        return this.toRLService<number>("/api/workflow/MergeAndAddNotificationToQueue").post(notification).$promise;
    }

    addNotificationsToQueue(charTypeID: number, recID: number, actionID: number, batchID: string, processID: number) {
        var recIDs: number[] = [];
        recIDs.push(recID);
        return this.toRLService<number>("/api/workflow/AddNotificationsToQueue").post({ charTypeID: charTypeID, recIDs: recIDs, actionID: actionID, batchID: batchID, processID: processID }).$promise;
    }

    runPreProcess(charTypeID: number, processID: number, actionID: number, recID: number, statusID: number) {
        return this.toRLService<boolean>("/api/workflow/RunPreProcess").post({ charTypeID: charTypeID, processID: processID, actionID: actionID, recID: recID, statusID: statusID }).$promise;
    }

    workflowUpdateEntityStatus(charTypeID: number, processID: number, actionID: number, recID: number, statusID: number) {
        var data = { charTypeID: charTypeID, processID: processID, actionID: actionID, recID: recID, statusID: statusID };
        return this.toRLService<Models.IWFNewStatus>("/api/workflow/WorkflowUpdateEntityStatus").post(data).$promise;
    }

    sendNotificationsFromQueue(charTypeID: number, recID: number, batchID: string) {
        return this.toRLService<number>("/api/workflow/SendNotificationsFromQueue").post({ charTypeID: charTypeID, recID: recID, batchID: batchID }).$promise;
    }

    runPostProcess(charTypeID: number, processID: number, actionID: number, recID: number, statusID: number) {
        return this.toRLService<boolean>("/api/workflow/RunPostProcess").post({ charTypeID: charTypeID, processID: processID, actionID: actionID, recID: recID, statusID: statusID }).$promise;
    }

    executeWorkflowActionAfterCopy(divID: number, charTypeID: number, recID: number) {
        return this.toRLService<Models.IDataResponse<boolean>>("/api/workflow/executeWorkflowActionAfterCopy").post({ divID: divID, charTypeID: charTypeID, recID: recID }).$promise;
    }
}